(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-sku"] && !Shopify.designMode) return;
  try {
    class ProductSku extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
    }

    connectedCallback() {
      // Écoute les changements de variante pour mettre à jour le SKU
      document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
      const { variant, productId } = event.detail || {};
      
      // Ne met à jour que si c'est le bon produit
      if (productId && this.productId && productId.toString() !== this.productId.toString()) {
        return;
      }

      const skuElement = this.querySelector('[data-sku-value]');
      if (skuElement && variant) {
        skuElement.textContent = variant.sku || this.dataset.emptyText || 'N/A';
      }
    }
  }

  if (!customElements.get('product-sku')) {
    customElements.define('product-sku', ProductSku);
  }
  } catch(e) { console.error(e); }
})();

})();
